<template>
    <div v-if="unit && !unit.loading">
        <a-breadcrumb>
            <a-breadcrumb-item v-for="a in unit.ancestors" :key="a.id">
                <router-link :to="'./' + a.id">{{ a.name }}</router-link>
            </a-breadcrumb-item>
        </a-breadcrumb>

        <a-card :title="unit.name" :loading="unit.loading">
            <a href="#" slot="extra"></a>
            <a-input v-model="unit.name">
                <a-button
                    slot="addonAfter"
                    type="link"
                    size="small"
                    @click="unit.save()"
                >
                    <i class="fa fa-save" />
                </a-button>
            </a-input>
            <div v-if="unit.parent_id != null">
                {{ $t('label.parentUnit') }}
                <Unitdropdown
                    :selectedUnitId="unit.parent_id"
                    @select="parentChanged"
                />
            </div>
        </a-card>

        <a-card :title="$t('label.managers')">
            <a-list :dataSource="unit.managers">
                <!-- <a-row slot="header" class="card-row bold">
                    <a-col :span="16" class="card-col">Manager</a-col>
                    <a-col :span="4" class="card-col"></a-col>
                </a-row>-->

                <a-row
                    slot="renderItem"
                    slot-scope="item"
                    class="card-row-hover"
                    justify="space-between"
                >
                    <a-col :span="16" class="card-col">
                        <router-link
                            :to="
                                '/organization/' +
                                    unit.id +
                                    '/users/' +
                                    item.user_id
                            "
                        >
                            {{ item.user_id }}
                        </router-link>
                    </a-col>
                    <a-col :span="2" class="card-col">
                        <Delete icon-only />
                    </a-col>
                </a-row>
            </a-list>
        </a-card>

        <a-card
            :title="$t('label.emailSuffixes')"
            :loading="unit.loading"
            :bodyStyle="{ padding: '0px' }"
        >
            <!-- <a href="#" slot="extra">
:title="$t('label.emailSuffixes')"                 <a-icon type="ellipsis" />
            </a>-->

            <a-list :dataSource="unit.all_email_suffixes">
                <a-row slot="header" class="card-row bold">
                    <a-col :span="16" class="card-col">Postfix</a-col>
                    <a-col :span="4" class="card-col">Enabled / Active</a-col>
                    <a-col :span="4" class="card-col"></a-col>
                </a-row>

                <a-row
                    slot="renderItem"
                    slot-scope="item"
                    class="card-row-hover"
                    justify="space-between"
                >
                    <a-col :span="16" class="card-col">{{
                        item.postfix
                    }}</a-col>
                    <a-col :span="6" class="card-col">
                        <a-switch :checked="item.enabled" />&nbsp;/
                        <a-switch :checked="item.active" />
                    </a-col>
                    <a-col :span="2" class="card-col">
                        <Delete icon-only />
                    </a-col>
                </a-row>
            </a-list>
            <!-- <pre>
              {{ unit.all_email_suffixes }}
            </pre>-->
        </a-card>

        <a-card>
            <Delete @confirm="deleteUnit" />
        </a-card>
    </div>
</template>

<script>
// import { mapActions } from 'vuex'
import Delete from '@/components/buttons/Delete'
import Unitdropdown from '@/components/UnitDropdown'
export default {
    props: ['unitId'],

    components: {
        Delete,
        Unitdropdown,
    },

    created() {
        this.unit = this.$resource('units', {
            id: this.unitId,
        })

        this.unit.on('fetch', this.onUnitFetchSuccess)

        // Ugly, UGLY hack to force update when model changes.
        // Todo: Fix this sometime.
        let that = this
        this.unit.on('change', () => {
            that.$forceUpdate()
        })

        this.unit.fetch({
            params: {
                include: 'allEmailSuffixes,managers',
            },
        })

        // this.getUnit(this.unitId)
        //     .then(unit => {
        //         this.unit = unit
        //     })
        //     .catch(err => {})
    },

    data() {
        return {
            unit: null,
        }
    },

    methods: {
        onUnitFetchSuccess() {
            this.loading = false
        },

        onUnitFetchError() {},

        parentChanged(newParent) {
            console.log('parentChanged', newParent)
            this.unit.parent_id = newParent.id
        },

        deleteUnit() {
            console.log('Deleting unit', this.unit.name, this.unit)
            let oldUnit = JSON.parse(JSON.stringify(this.unit))
            this.unit.delete().then(() => {
                console.log('Deleted', oldUnit)
                this.$router.push('./' + oldUnit.ancestors.pop().id)
            })
        },
    },

    // ...mapActions({
    //     getUnit: 'api/getResourceById'
    // })
}
</script>
<style scoped>
.card-col {
    padding: 10px;
    padding-left: 20px;
}
.card-row-hover:hover {
    background: rgba(1, 1, 1, 0.02);
}
</style>
